"use client";

import React from "react";
import { AdvancedTicketList } from "@/features/tickets/components/AdvancedTicketList";
import { DataFetchingWrapper } from "@/components/ui/data/data-fetching";
import type { Contact } from "@/lib/types/database";
import { CreateTicketButton } from "@/components/shared/tickets/CreateTicketButton";
import { useContextualTableFilter } from "@/lib/hooks/search/useContextualTableFilter";
import { ContextualTableFilter } from "@/components/shared/tables/ContextualTableFilter";

interface ContactTicketsProps {
  client: Contact;
  className?: string;
}

export const ContactTickets: React.FC<ContactTicketsProps> = ({ client, className = "" }) => {
  // Filter tickets by this client's ID
  const ticketFilters = {
    clientId: client.id,
  };

  const { contextFilterLabel, isContextFilterActive, clearContextFilter } =
    useContextualTableFilter("tickets");

  return (
    <div className={`space-y-4 ${className}`}>
      <div className="flex items-center justify-between">
        <div>
          <h3 className="text-lg font-semibold text-card-foreground">Tickets for {client.name}</h3>
          <p className="text-sm text-gray-600 mt-1 dark:text-gray-400">View and manage all tickets for this client</p>
        </div>
        <CreateTicketButton entityName={client.name} />
      </div>

      <ContextualTableFilter
        label={contextFilterLabel}
        isActive={isContextFilterActive}
        onClear={clearContextFilter}
      />

      <div className="bg-card rounded-lg border border-gray-200 p-4 dark:border-gray-700">
        <AdvancedTicketList filters={ticketFilters} />
      </div>
    </div>
  );
};

export { ContactTickets as ClientTickets };
